import contentQuery from "../../helpers/contentQuery"

const postQuery = (slug: string | string[] | undefined) => {
  return `
  *[_type == "post" && slug.current == "${slug}"]{
      _type,
      excerpt,
      pageTitle,
      pageSubtitle,
      _updatedAt,
      "slug": slug.current,
      _id,
      logo,
      pageDescription,
      meta,
      author{
          "name": @.reference->name,
          "bio": @.reference->bio,
          "userpic": @.reference->userpic,
          "socialMedias": @.reference->socialMedias
      },
      ${contentQuery},
      relatedBonuses {
        ...,
        "bonusesList": bonusesList[]-> { 
          ...,
          "slug": slug.current,
       }
    },
    relatedListings {
        ...,
        "listingsList": listingsList[]-> { 
            ...,
            "slug": slug.current,
            author{
                "name": @.reference->name,
                "bio": @.reference->bio,
                "userpic": @.reference->userpic,
                "socialMedias": @.reference->socialMedias
            }
         }
    },
    relatedPosts {
      ...,
      "postsList": postsList[]-> { 
          ...,
          "slug": slug.current,
          author{
              "name": @.reference->name,
              "bio": @.reference->bio,
              "userpic": @.reference->userpic,
              "socialMedias": @.reference->socialMedias
          }
       }
    },
  }[0]`
} 

export default postQuery